import React from 'react';
//import styled from 'styled-components'
// Layout Component
import TextBlockCard from './TextBlockCard';
import TextBlockImage from './TextBlockImage';
import TextBlockImages from './TextBlockImages';
import LefthandTextColumn from './LefthandTextColumn';
import RighthandTextColumn from './RighthandTextColumn';
// Components
import Divider from '../../components/Divider/index';
// Atoms
import { Section } from '../../atoms/section/Section'
// Globals
import { Column, Wrapper, Row } from '../../global/grid'
import { col } from '../../global/theme';


const TextBlockDefault = ({
  title,
  subTitle,
  text,
  addTextColumn,
  textColumn,
  addButton,
  addCallout,
  calloutTitle,
  calloutLinks,
  imageWidth,
  imageSpacing,
  addCard,
  cardTitle,
  cardLink,
  button,
  addImage,
  image,
  addImages,
  images,
}) => {
  //console.log(imageWidth);
    return (
      <Section>
        <Wrapper>
            <Row paddedRow>
              <Column selfStart xsWidth={col.twelve} mdWidth={col.six}>
                <LefthandTextColumn
                  title={title}
                  subTitle={subTitle}
                  text={text}
                  addButton={addButton}
                  button={button}
                  addCallout={addCallout}
                  calloutTitle={calloutTitle}
                  calloutLinks={calloutLinks}
                />
              </Column>
              <RighthandTextColumn
                addTextColumn={addTextColumn}
                textColumn={textColumn}
                addButton={addButton}
                button={button}
              />
              <TextBlockCard
                cardTitle={cardTitle}
                cardLink={cardLink}
                addCard={addCard}
              />
              <TextBlockImage
                image={image}
                addImage={addImage}
                imageWidth={imageWidth}
                imageSpacing={imageSpacing}
              />
              <TextBlockImages
                images={images}
                addImages={addImages}
              />
            </Row>
            <Divider/>
        </Wrapper>
      </Section> 
    )
}

export default TextBlockDefault;
